import { useContext, createContext } from 'react';

const NotificationsContext = createContext({});

export function NotificationsProvider({ notificationsData, refreshData, isLoading, children }) {
  return (
    <NotificationsContext.Provider value={{
      notificationsData,
      userIds: Object.keys(notificationsData),
      refreshData,
      isLoading,
    }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationsContext);
}